import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ResourcePage from "@/components/ResourcePage";
import { Badge } from "@/components/Common";

export default function Purchases() {
  const [suppliers, setSuppliers] = useState([]);
  const [branches, setBranches] = useState([]);
  useEffect(() => {
    api.get("/suppliers").then(({ data }) => setSuppliers(data));
    api.get("/branches").then(({ data }) => setBranches(data));
  }, []);
  const supplierMap = Object.fromEntries(suppliers.map((s) => [s.id, s.name]));
  return (
    <ResourcePage
      endpoint="/purchases"
      testidPrefix="purchase"
      eyebrow="Stakeholders"
      title="Purchase History"
      subtitle="Procurement records and supplier invoices."
      ctaLabel="Record purchase"
      fields={[
        { name: "supplier_id", label: "Supplier", type: "select", required: true,
          options: suppliers.map((s) => ({ value: s.id, label: s.name })) },
        { name: "branch", label: "Branch", type: "select", required: true, options: branches.map((b) => b.name) },
        { name: "invoice_number", label: "Invoice #" },
        { name: "purchase_date", label: "Purchase date", type: "date" },
        { name: "items_description", label: "Items", type: "textarea" },
        { name: "total_amount", label: "Total (UGX)", type: "number" },
        { name: "currency", label: "Currency", default: "UGX" },
        { name: "payment_status", label: "Payment", type: "select", default: "unpaid",
          options: ["unpaid", "partial", "paid"] },
      ]}
      columns={[
        { key: "invoice_number", label: "Invoice #" },
        { key: "supplier_id", label: "Supplier", render: (i) => supplierMap[i.supplier_id] || "—" },
        { key: "branch", label: "Branch" },
        { key: "purchase_date", label: "Date" },
        { key: "total_amount", label: "Amount", render: (i) => i.total_amount ? `${i.currency || "UGX"} ${Number(i.total_amount).toLocaleString()}` : "—" },
        { key: "payment_status", label: "Payment", render: (i) => <Badge tone={i.payment_status === "paid" ? "emerald" : i.payment_status === "partial" ? "amber" : "red"}>{i.payment_status}</Badge> },
      ]}
      searchKeys={["invoice_number", "items_description"]}
    />
  );
}
